import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M6 6h2v12H6zm3.5 6 8.5 6V6z"
}), 'SkipPrevious');